import axios from 'axios';
import config from '../common/config';

export function saveTripProfile(token, rideId, profile) {
  return axios.post(
    `${config.config.ROOT_URL}/update_trip_profile_api/${rideId}`,
    { profile },
    { headers: { Authorization: `Bearer ${token}` } },
  );
}

export default { saveTripProfile };
